const CANCELLED = 0;
const APPLICATION = 1;
const UNDERWRITING = 2;
const DECLINED = 3;
const DISBURSEMENT = 4;
const REGULAR_RE_PAYMENT = 5;
const COLLECTION = 6;
const POST_COLLECTION = 7;
const RE_PAID = 8;

export {
  CANCELLED,
  APPLICATION,
  RE_PAID,
  UNDERWRITING,
  DECLINED,
  DISBURSEMENT,
  REGULAR_RE_PAYMENT,
  COLLECTION,
  POST_COLLECTION,
};
